import {
  createFrontendModule,
  errorApiRef,
  identityApiRef,
  storageApiRef,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import homePlugin from '@backstage/plugin-home/alpha';
import {
  VisitsStorageApi,
  VisitsWebStorageApi,
  visitsApiRef,
} from '@backstage/plugin-home';
import { HomePage } from '../components/pages/home';

const ALLOWED_VISIT_PATH_PREFIXES = [
  '/catalog/',
  '/docs/default/component/portal-docs/',
] as const;

const isAllowedVisitPathname = (pathname: string): boolean =>
  ALLOWED_VISIT_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));

const homePageOverride = homePlugin.getExtension('page:home').override({
  params: {
    path: '/',
    loader: async () => compatWrapper(<HomePage />),
  },
});

const visitsApiEnabled = homePlugin.getExtension('api:home/visits').override({
  disabled: false,
  params: defineParams =>
    defineParams({
      api: visitsApiRef,
      deps: {
        storageApi: storageApiRef,
        identityApi: identityApiRef,
        errorApi: errorApiRef,
      },
      factory: ({ storageApi, identityApi, errorApi }) => {
        if (storageApi) {
          return VisitsStorageApi.create({
            storageApi,
            identityApi,
            canSave: visit => isAllowedVisitPathname(visit.pathname),
          });
        }

        return VisitsWebStorageApi.create({
          identityApi,
          errorApi,
        });
      },
    }),
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [homePageOverride, visitsApiEnabled],
});
